module.exports = __webpack_public_path__ + "static/media/glamorous-temptation.d6ca16bc.md";